import gql from 'graphql-tag';

export const GET_CHANNEL_DUPLICATES_ACTIVE_LIST = gql`
  {
    channelActiveDuplicates
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/channels/activeDuplicates.js